import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'incomplete',
	pure: true,
})
export class IncompletePipe implements PipeTransform {
	transform(value: any, _args?: any): any {
		// any number of commas or whitespace characters
		const regex = /[\,\s]*/gi;
		return value && value.toString().trim() && value.toString().replace(regex, '') ? value : '——';
	}
}
